module.exports = __webpack_public_path__ + "img/35_31.4073e46b.png";